import React from 'react';

import Tags from '@rover/icons/svg/tags.svg';
import { Box, Flex } from '@rover/kibble/core';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';
import Alert from '@rover/kibble/patterns/Alert';
import useTheme from '@rover/kibble/themes/useTheme';
import { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/AlertSeverity';
import {
  PriceTransparencyLevel,
  PriceTransparencyLevels,
} from '@rover/types/src/PriceTransparencyLevel';

import { GET_PRICE_TRANSPARENCY_CONDENSED_BANNER_TEXT } from './constants';

export type Props = {
  priceTransparencyLevel?: PriceTransparencyLevel;
  bookingFeePercentage?: string;
  onClick: () => void;
  isSitterProfile?: boolean;
};

const PtCondensedBanner = ({
  priceTransparencyLevel,
  bookingFeePercentage,
  onClick,
  isSitterProfile = false,
}: Props): JSX.Element | null => {
  const { colors } = useTheme();
  const priceTransparencyCondensedText = GET_PRICE_TRANSPARENCY_CONDENSED_BANNER_TEXT(
    priceTransparencyLevel,
    bookingFeePercentage
  );
  if (!priceTransparencyCondensedText) return null;
  return (
    <Alert
      severity={
        priceTransparencyLevel === PriceTransparencyLevels.full_condensed
          ? AlertSeverity.SUCCESS
          : AlertSeverity.INFO
      }
      border="0px"
      borderRadius={isSitterProfile ? '4px' : '0px'}
      mb="0x"
      testID="pt-condensed-header"
      onPress={onClick}
    >
      <Flex flexDirection="row" alignItems="center">
        <Box sx={{ flexShrink: 0, width: 21, height: 21 }}>
          <Tags
            fill={
              priceTransparencyLevel === PriceTransparencyLevels.full_condensed
                ? colors.green[600]
                : colors.cyan[600]
            }
            aria-hidden="true"
          />
        </Box>
        <Box flex="1">
          <TextWithSingleInlineLink
            asParagraph
            testID="mock-inline-link"
            paragraphText={priceTransparencyCondensedText}
            href="#"
            onClick={onClick}
            ml="2x"
            size="100"
            mb="0x"
          />
        </Box>
      </Flex>
    </Alert>
  );
};

export default PtCondensedBanner;
